import { featureItems } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3">平台优势</h2>
          <p className="text-foreground-600 text-sm">为什么数百万影迷选择小小影院</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {featureItems.map((item) => (
            <div
              key={item.title}
              className="p-5 rounded-xl bg-background-50 border border-background-200/60 text-center hover:border-primary-200/60 transition-colors cursor-pointer group"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-500 mx-auto mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}